<template>
  <grids
    v-validate="'required'"
    :title="label"
    :value.sync="formModel.heirsData"
    :root-form-model="{ ...formModel, ...rootFormModel }"
    :config="dataGridConfig"
    :view-mode="viewMode"
    :error-message="errors.first(label)"
  ></grids>
</template>

<script>
import { prepareDynamicFormFieldsForAPI } from '@/modules/global/helpers/utils';
import Grids from '@/components/shared/grids';
export default {
  components: { Grids },
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    rootFormModel: {
      type: Object,
      required: true,
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      label: 'بيانات الورثة',
      dataGridConfig: {
        headers: [
          {
            value: 'heirName',
            name: 'heirName',
            text: 'الاسم',
            header: 'الاسم',
            order: 1,
          },
          {
            value: 'idNumber',
            name: 'idNumber',
            text: 'رقم الهوية',
            header: 'رقم الهوية',
            order: 2,
          },
          {
            value: 'deceasedRelationship',
            name: 'deceasedRelationship',
            text: 'صلة القرابة بالمتوفى',
            header: 'صلة القرابة بالمتوفى',
            order: 3,
          },
        ],
        filters: [],
        actions: [
          {
            actionType: 6,
            actionName: 'إضافة',
          },
          {
            actionType: 7,
            actionName: 'تعديل',
          },
          {
            actionType: 8,
            actionName: 'حذف',
          },
          {
            actionType: 9,
            actionName: 'معاينة',
          },
        ],
        formLabel: 'الورثة',
        fields: prepareDynamicFormFieldsForAPI([
          {
            typeId: 11,
            name: 'section',
            label: 'بيانات الوريث',
            sortIndex: 1,
            properties: {
              dataGridConfig: null,
              dateConfig: {},
            },
            fields: [
              {
                typeId: 7,
                name: 'heirGender',
                label: 'النوع',
                columnSize: 12,
                sortIndex: 1,
                properties: {
                  validations: { required: 'true' },
                  externalDataSource: {},
                  textName: 'heirGenderName',
                  pickListId: 7,
                  dataGridConfig: null,
                  dataSource: [
                    {
                      key: 1,
                      id: 1,
                      value: 'ذكر',
                      name: 'ذكر',
                    },
                    {
                      key: 2,
                      id: 2,
                      value: 'أنثى',
                      name: 'أنثى',
                    },
                  ],
                  dateConfig: {},
                },
                description: 'النوع',
                fields: [],
              },
              {
                typeId: 1,
                name: 'deceasedRelationship',
                label: 'صلة القرابة بالمتوفى',
                columnSize: 4,
                sortIndex: 2,
                properties: {
                  validations: { required: 'true' },
                  dataGridConfig: null,
                  dateConfig: {},
                  showDescriptionTooltip: true,
                },
                description: 'ابنه، بنته، زوجته، ... إلخ',
                fields: [],
              },
              {
                typeId: 1,
                name: 'heirName',
                label: 'الاسم',
                columnSize: 4,
                sortIndex: 3,
                properties: {
                  validations: { required: 'true' },
                  dataGridConfig: null,
                  dateConfig: {},
                },
                description: 'الاسم',
                fields: [],
              },
              {
                typeId: 1,
                name: 'idNumber',
                label: 'رقم الهوية',
                columnSize: 4,
                sortIndex: 4,
                properties: {
                  validations: {
                    required: 'true',
                    numeric: 'true',
                    isValid:
                      '\'رقم الهوية يجب أن يكون 10 أرقام\', obj.idNumber.length == 10',
                  },
                  dataGridConfig: null,
                  dateConfig: {},
                },
                description: 'رقم الهوية',
                fields: [],
              },
              {
                typeId: 3,
                name: 'birthDate',
                label: 'تاريـخ الميلاد',
                columnSize: 4,
                sortIndex: 5,
                properties: {
                  validations: { required: 'true' },
                  dataGridConfig: null,
                  dateConfig: {},
                },
                description: 'تاريـخ الميلاد',
                fields: [],
              },
              {
                typeId: 4,
                name: 'heirCondition',
                label: 'بيان حال الوارث',
                columnSize: 4,
                sortIndex: 6,
                properties: {
                  validations: { required: 'true' },
                  externalDataSource: {},
                  textName: 'heirConditionName',
                  pickListId: 73,
                  dataGridConfig: null,
                  dataSource: [
                    {
                      key: 1,
                      id: 1,
                      value: 'راشد',
                      name: 'راشد',
                    },
                    {
                      key: 2,
                      id: 2,
                      value: ' قاصر سناً',
                      name: ' قاصر سناً',
                    },
                    {
                      key: 3,
                      id: 3,
                      value: 'قاصر عقلاً',
                      name: 'قاصر عقلاً',
                    },
                    {
                      key: 4,
                      id: 4,
                      value: 'متوفى',
                      name: 'متوفى',
                    },
                  ],
                  dateConfig: {},
                  if: '!obj.heirGender || obj.heirGender==1',
                  disabledIf: '!obj.heirGender',
                },
                description: 'بيان حال الوارث',
                fields: [],
              },
              {
                typeId: 4,
                name: 'heirCondition',
                label: 'بيان حال الوارث',
                columnSize: 4,
                sortIndex: 7,
                properties: {
                  validations: { required: 'true' },
                  dateConfig: {},
                  externalDataSource: {},
                  textName: 'heirConditionName',
                  pickListId: 82,
                  if: 'obj.heirGender==2',
                  dataGridConfig: null,
                  dataSource: [
                    {
                      key: 1,
                      id: 1,
                      value: 'راشدة',
                      name: 'راشدة',
                    },
                    {
                      key: 2,
                      id: 2,
                      value: 'قاصرة سنًا',
                      name: 'قاصرة سنًا',
                    },
                    {
                      key: 3,
                      id: 3,
                      value: 'قاصرة عقلًا',
                      name: 'قاصرة عقلًا',
                    },
                    {
                      key: 4,
                      id: 4,
                      value: 'متوفية',
                      name: 'متوفية',
                    },
                    {
                      key: 5,
                      id: 5,
                      value: 'حامل',
                      name: 'حامل',
                    },
                  ],
                },
                description: 'بيان حال الوارث',
                fields: [],
              },
              {
                typeId: 3,
                name: 'heirdeathDate',
                label: 'تاريخ وفاة الوارث',
                columnSize: 4,
                sortIndex: 8,
                properties: {
                  validations: {},
                  dateConfig: {},
                  disabledIf: '',
                  show: 'obj.heirCondition==4',
                  dataGridConfig: null,
                },
                description: 'تاريخ وفاة الوارث',
                fields: [],
              },
            ],
          },
          {
            typeId: 11,
            name: 'section',
            label: 'بيانات أبناء الورثة',
            sortIndex: 2,
            properties: {
              dataGridConfig: null,
              dateConfig: {},
            },
            fields: [
              {
                typeId: 1,
                name: 'issuerSubGrid',
                label: 'جهة إصدار صك حصر الورثة',
                columnSize: 4,
                sortIndex: 1,
                properties: {
                  show: 'obj.heirCondition==4',
                  validations: { required: 'true' },
                  dataGridConfig: null,
                  dateConfig: {},
                },
                description: 'جهة إصدار صك حصر الورثة',
                fields: [],
              },
              {
                typeId: 1,
                name: 'instrumentNumberSubGrid',
                label: 'رقم الصك',
                columnSize: 4,
                sortIndex: 2,
                properties: {
                  show: 'obj.heirCondition==4',
                  validations: {
                    required: 'true',
                    numeric: 'true',
                    isValid:
                      '\'رقم الصك يجب أن يكون 14 رقم كحد أقصى\', obj.instrumentNumberSubGrid.length <= 14',
                  },
                  dataGridConfig: null,
                  dateConfig: {},
                },
                description: 'رقم الصك',
                fields: [],
              },
              {
                typeId: 3,
                name: 'dateSubGrid',
                label: 'تاريخ الصـك',
                columnSize: 4,
                sortIndex: 3,
                properties: {
                  show: 'obj.heirCondition==4',
                  validations: { required: 'true' },
                  dataGridConfig: null,
                  dateConfig: {},
                },
                description: 'تاريخ الصـك',
                fields: [],
              },
              {
                typeId: 22,
                name: 'heirsSubGrid',
                label: 'بيانات الورثة',
                columnSize: 12,
                sortIndex: 4,
                properties: {
                  if: 'obj.heirCondition==4',
                  validations: {},
                  gridId: 41,
                  dataGridConfig: {
                    headers: [
                      {
                        value: 'heirNameSubGrid',
                        name: 'heirNameSubGrid',
                        text: 'الاسم',
                        header: 'الاسم',
                        order: 1,
                      },
                      {
                        value: 'idNumberSubGrid',
                        name: 'idNumberSubGrid',
                        text: 'رقم الهوية',
                        header: 'رقم الهوية',
                        order: 2,
                      },
                      {
                        value: 'deceasedRelationshipSubGrid',
                        name: 'deceasedRelationshipSubGrid',
                        text: 'صلة القرابة بالمتوفى',
                        header: 'صلة القرابة بالمتوفى',
                        order: 3,
                      },
                    ],
                    filters: [],
                    actions: [
                      {
                        actionType: 6,
                        actionName: 'إضافة',
                      },
                      {
                        actionType: 7,
                        actionName: 'تعديل',
                      },
                      {
                        actionType: 8,
                        actionName: 'حذف',
                      },
                      {
                        actionType: 9,
                        actionName: 'معاينة',
                      },
                    ],
                    formLabel: 'بيانات ورثة المتوفى الوارث',
                    fields: [
                      {
                        typeId: 7,
                        name: 'heirGenderSubGrid',
                        label: 'النوع',
                        columnSize: 12,
                        sortIndex: 1,
                        properties:
                        {
                          validations: { 'required': 'true' },
                          externalDataSource: {},
                          textName: 'heirGenderSubGridName',
                          dataGridConfig: null,
                          dataSource: [
                            {
                              key: 1,
                              id: 1,
                              value: 'ذكر',
                              name: 'ذكر',
                            },
                            {
                              key: 2,
                              id: 2,
                              value: 'أنثى',
                              name: 'أنثى',
                            },
                          ],
                          dateConfig: {},
                        }
                        ,
                        description: 'النوع',
                        fields: [],
                      },
                      {
                        typeId: 1,
                        name: 'deceasedRelationshipSubGrid',
                        label: 'صلة القرابة بالمتوفى',
                        columnSize: 4,
                        sortIndex: 2,
                        properties:
                        {
                          validations: { 'required': 'true' },
                          dataGridConfig: null,
                          dateConfig: {},
                          showDescriptionTooltip: true,
                        }
                        ,
                        description: 'ابنه، بنته، زوجته، ... إلخ',
                        fields: [],
                      },
                      {
                        typeId: 1,
                        name: 'heirNameSubGrid',
                        label: 'الاسم',
                        columnSize: 4,
                        sortIndex: 3,
                        properties:
                        {
                          validations: { 'required': 'true' },
                          dataGridConfig: null,
                          dateConfig: {},
                        }
                        ,
                        description: 'الاسم',
                        fields: [],
                      },
                      {
                        typeId: 1,
                        name: 'idNumberSubGrid',
                        label: 'رقم الهوية',
                        columnSize: 4,
                        sortIndex: 4,
                        properties:
                        {
                          validations: {
                            required: 'true',
                            numeric: 'true',
                            isValid: '\'رقم الهوية يجب أن يكون 10 أرقام\', obj.idNumberSubGrid.length == 10',
                          },
                          dataGridConfig: null,
                          dateConfig: {},
                        }
                        ,
                        description: 'رقم الهوية',
                        fields: [],
                      },
                      {

                        typeId: 3,
                        name: 'birthDateSubGrid',
                        label: 'تاريخ الميلاد',
                        columnSize: 4,
                        sortIndex: 5,
                        properties:
                        {
                          validations: { required: 'true' },
                          dataGridConfig: null,
                          dateConfig: {},
                        }
                        ,
                        description: 'تاريخ الميلاد',
                        fields: [],
                      },
                      {

                        typeId: 4,
                        name: 'heirConditionSubGrid',
                        label: 'بيان حال الوارث',
                        columnSize: 4,
                        sortIndex: 6,
                        properties:
                        {
                          validations: { required: 'true' },
                          externalDataSource: {},
                          textName: 'heirConditionSubGridName',
                          dataGridConfig: null,
                          dataSource: [
                            {
                              key: 1,
                              id: 1,
                              value: 'راشد',
                              name: 'راشد',
                            },
                            {
                              key: 2,
                              id: 2,
                              value: ' قاصر سناً',
                              name: ' قاصر سناً',
                            },
                            {
                              key: 3,
                              id: 3,
                              value: 'قاصر عقلاً',
                              name: 'قاصر عقلاً',
                            },
                            {
                              key: 4,
                              id: 4,
                              value: 'متوفى',
                              name: 'متوفى',
                            },
                          ],
                          dateConfig: {},
                          if: '!obj.heirGenderSubGrid || obj.heirGenderSubGrid == 1',
                          disabledIf: '!obj.heirGenderSubGrid',
                        }
                        ,
                        description: 'بيان حال الوارث',
                        fields: [],
                      },
                      {
                        typeId: 4,
                        name: 'heirConditionSubGrid',
                        label: 'بيان حال الوارث',
                        columnSize: 4,
                        sortIndex: 7,
                        properties:
                        {
                          validations: { required: 'true' },
                          dateConfig: {},
                          externalDataSource: {},
                          textName: 'heirConditionSubGridName',
                          if: 'obj.heirGenderSubGrid==2',
                          dataGridConfig: null,
                          dataSource: [
                            {
                              key: 1,
                              id: 1,
                              value: 'راشدة',
                              name: 'راشدة',
                            },
                            {
                              key: 2,
                              id: 2,
                              value: 'قاصرة سنًا',
                              name: 'قاصرة سنًا',
                            },
                            {
                              key: 3,
                              id: 3,
                              value: 'قاصرة عقلًا',
                              name: 'قاصرة عقلًا',
                            },
                            {
                              key: 4,
                              id: 4,
                              value: 'متوفية',
                              name: 'متوفية',
                            },
                            {
                              key: 5,
                              id: 5,
                              value: 'حامل',
                              name: 'حامل',
                            },
                          ],
                        }
                        ,
                        description: 'بيان حال الوارث',
                        fields: [],
                      },
                    ],
                  },
                  dateConfig: {},
                },
                description: 'بيانات الورثة',
                fields: [],
              },
            ],
          },
        ]),
      },
    };
  },
};
</script>
